<template>
    <!-- 学校学习 -->
    <div id="studyDiv" class="wrap">
        <el-dialog :visible.sync="studyDivVisible" 
        :before-close="study_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
                <center><font color="ff0000" class="title">学习</font></center><hr color="000000">
                <div v-if="null != propTypeEnumList" id="propTypeEnumList">
                    <select id="chooseProperty" @change="chooseProperty(this);" v-model="selectedProperty">
                        <option value="">请选择</option>
                        <option v-for="propTypeEnum in propTypeEnumList" v-bind:key="propTypeEnum.propType" 
                        :value="propTypeEnum.propType">{{propTypeEnum.propTypeStr}}</option>
                    </select>
                    <div>
                        {{propertyValue}}{{curCost}}
                    </div>
                    <div v-show="studyBtn" class="forget-tip">
                        遗忘 1 点需 {{forgetCost}} 金币，每次遗忘 1 点，费用不随属性值变化
                    </div>
                    <div v-show="studyBtn">
                        <el-button type="primary" plain size="mini" @click="studyProperty();">学习</el-button>
                        <el-button type="warning" plain size="mini" :disabled="propertyValueNum <= 0"
                        @click="forgetProperty();">遗忘 1 点</el-button>
                    </div>
                </div>
                <div style="clear:both"></div>
          </div>
        </el-dialog>
        
    </div>
</template>

<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'study',
  props:{
    studyDivVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
  },
  data() {
    return {
        propTypeEnumList: [],
        loading: false,
        propertyValue: "",
        propertyValueNum: 0,
        curCost: "",
        forgetCost: 5000,
        selectedProperty: "",
        studyBtn: false
    };
  },
  watch: {
    studyDivVisible: {
      handler(newVal) {
        if (newVal === true) {
          this.showPropTypeEnumList();
        }
      }
    }
  },
  mounted: function () {
      if (this.studyDivVisible) {
          this.showPropTypeEnumList();
      }
  },
  methods: {
    study_dialog_close(){
      this.$emit("study_dialog_close");
    },
    //学习
    showPropTypeEnumList: function(){
        this.propTypeEnumList = [];
        this.loading = true;
        getRequest('/user/study/getAllProperty', {
        }).then(resp=> {
          this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data.propTypeEnumList) {
                this.propTypeEnumList = respData.data.propTypeEnumList;
              }
            } else {
              Message.error(respData.message);
            }
          } else {
            //失败
            Message.error('查询全部可学习属性失败');
          }
        }, resp=> {
          Message.error('查询全部可学习属性异常');
        });
    },
    chooseProperty: function() {
        var _this = this;
        this.loading = true;
        this.propertyValue = "";
        this.propertyValueNum = 0;
        this.curCost = "";
        _this.studyBtn = false;
        getRequest('/user/study/chooseProperty', {
            propertyName: this.selectedProperty
        }).then(resp=> {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              if (null != respData.data.propertyValue) {
                _this.propertyValueNum = respData.data.propertyValue;
                _this.propertyValue = "当前值：" + respData.data.propertyValue;
                _this.curCost = "，本次学习费用：" + respData.data.curCost;
                if (null != respData.data.forgetCost) {
                  _this.forgetCost = respData.data.forgetCost;
                }
                _this.studyBtn = true;
              }
            } else {
              Message.error(respData.message);
            }
          } else {
            //失败
            Message.error('查询学习属性失败');
          }
        }, resp=> {
          Message.error('查询学习属性异常');
        });
    },
    studyProperty: function() {
        var _this = this;
        this.loading = true;
        postRequest('/user/study/studyProperty', {
            propertyName: this.selectedProperty
        }).then(resp=> {
          _this.loading = false;
          if (resp.status == 200) {
            // 学习必扣体力/疲劳，成功或「未果仅收部分费」都扣钱——无论业务成败都刷新用户详情，
            // 否则金额/体力/疲劳/属性滞留旧值（2026-10-03 用户反馈学习后金钱不实时更新）
            _this.$store.dispatch('user/fetchUserDetail');
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
                Message.success(respData.message);
            } else {
              Message.error(respData.message);
            }
            _this.study_dialog_close();
          } else {
            //失败
            Message.error('学习失败');
          }
        }, resp=> {
          Message.error('学习异常');
        });
    },
    // 遗忘 1 点属性：固定收费、不递增，二次确认后调用
    forgetProperty: function() {
        var _this = this;
        if (this.propertyValueNum <= 0) {
            Message.error('这项属性已经没有可遗忘的点数了');
            return;
        }
        this.$confirm('真的要遗忘 1 点【' + this.selectedPropStr() + '】吗？需要 ' + this.forgetCost + ' 金币。',
            '遗忘属性', {
                confirmButtonText: '确认遗忘',
                cancelButtonText: '再想想',
                type: 'warning'
            }).then(() => {
                _this.loading = true;
                postRequest('/user/study/forgetProperty', {
                    propertyName: _this.selectedProperty
                }).then(resp=> {
                  _this.loading = false;
                  // 遗忘必扣金币，无论成败都刷新用户详情，避免金额/属性滞留旧值
                  _this.$store.dispatch('user/fetchUserDetail');
                  if (resp.status == 200) {
                    var respData = resp.data;
                    if (200 == respData.status) {
                        Message.success(respData.message);
                    } else {
                      Message.error(respData.message);
                    }
                    _this.study_dialog_close();
                  } else {
                    Message.error('遗忘失败');
                  }
                }, resp=> {
                  _this.loading = false;
                  Message.error('遗忘异常');
                });
            }).catch(() => {});
    },
    // 当前选中属性的中文名（用于确认弹窗）
    selectedPropStr: function() {
        for (var i = 0; i < this.propTypeEnumList.length; i++) {
            if (this.propTypeEnumList[i].propType == this.selectedProperty) {
                return this.propTypeEnumList[i].propTypeStr;
            }
        }
        return this.selectedProperty;
    },
  },
  beforeDestroy: function() {
  }
}
</script>

<style scoped>
a {
    cursor: pointer;
    color: blue;
}
.wrap {
    margin:auto;
    text-align: center;
}
.title {
    font-size: 2em;
    line-height: 2em;
}
#propTypeEnumList {
    margin: 10px;
}

#propTypeEnumList select {
    height: 30px;
    line-height: 30px;
}
#propTypeEnumList div {
    margin: 10px;
}
.itembg {
    width:80%;
    min-height: 200px;
    text-align: center;
    margin: 0 auto;
}
.forget-tip {
    font-size: 12px;
    color: #909399;
}
</style>